

























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import userInterface from '../interface/user';
import avatars from '../../enums/avatars';
import WagonIcon from './WagonIcon.vue';

@Component({
  computed: { ...mapGetters(['getUsers', 'getTurn']) },
  components: { WagonIcon },
})
export default class UserSide extends Vue {
  @Prop({ default: 0 }) private timer!: number;

  getUsers!: userInterface[];

  getTurn!: number;

  get activePlayer(): userInterface {
    return this.getUsers[this.getTurn % this.getUsers.length];
  }

  avatars = avatars;
}
